import { useNavigate } from "react-router-dom";

function ContactPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#03070d", color: "white", padding: "70px 20px 40px" }}>
      <button onClick={() => navigate("/")} style={backBtn}>← Retour</button>

      <div style={{ ...card, textAlign: "center" }}>
        <h1 style={title}>Contact</h1>

        <p style={{ fontSize: 18 }}>
          Pour toute demande concernant EVO-LIVE, vous pouvez nous contacter par email.
        </p>

        <div style={mailBox}>
          <p style={{ margin: 0, opacity: 0.8 }}>Email officiel</p>
          <h2 style={{ color: "#00f2ff", marginBottom: 0 }}>admin.live.evo@gmail.com</h2>
        </div>

        <div style={section}>
          <h2 style={sub}>Support utilisateurs</h2>
          <p>
            Pour une aide liée à votre compte, un problème de connexion, une erreur technique,
            une transaction, des coins, un remboursement ou un contenu publié.
          </p>
        </div>

        <div style={section}>
          <h2 style={sub}>Signalements et sécurité</h2>
          <p>
            Pour signaler un contenu, un live, un message, un comportement abusif,
            une usurpation d’identité ou une atteinte au droit à l’image.
          </p>
        </div>

        <div style={section}>
          <h2 style={sub}>Demandes professionnelles</h2>
          <p>
            Pour les partenariats, demandes presse, collaborations, informations légales
            ou demandes concernant EVO-LIVE SAS.
          </p>
        </div>

        <div style={noticeBox}>
          <p style={{ margin: 0 }}>
            Merci d’indiquer dans votre message votre email de compte, votre pseudo,
            le motif de la demande et toute information utile pour faciliter le traitement.
          </p>
        </div>

        <a href="/assistance" style={{color: "#00f2ff", display: "inline-block", marginTop: 20}}>Ouvrir le centre d’assistance →</a>
        <p style={footer}>EVO-LIVE SAS – Tous droits réservés</p>
      </div>
    </div>
  );
}

const backBtn = {
  position: "fixed",
  top: 20,
  left: 20,
  zIndex: 9999,
  border: "1px solid rgba(0,242,255,0.55)",
  background: "rgba(0, 12, 20, 0.9)",
  color: "#00f2ff",
  padding: "10px 16px",
  borderRadius: 999,
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 0 18px rgba(0,242,255,0.35)",
};

const card = {
  maxWidth: 850,
  margin: "auto",
  padding: "32px 24px",
  borderRadius: 26,
  background: "rgba(0, 12, 20, 0.82)",
  border: "1px solid rgba(0,242,255,0.28)",
  boxShadow: "0 0 35px rgba(0,242,255,0.14)",
  lineHeight: 1.7,
};

const mailBox = {
  marginTop: 35,
  padding: 25,
  borderRadius: 22,
  border: "1px solid rgba(0,242,255,0.35)",
  boxShadow: "0 0 25px rgba(0,242,255,0.18)",
};

const section = {
  marginTop: 28,
  padding: "18px 20px",
  borderRadius: 20,
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const noticeBox = {
  marginTop: 30,
  padding: 20,
  borderRadius: 20,
  background: "rgba(0,242,255,0.08)",
  border: "1px solid rgba(0,242,255,0.25)",
};

const title = {
  color: "#00f2ff",
  marginBottom: 25,
  textShadow: "0 0 18px rgba(0,242,255,0.6)",
};

const sub = {
  color: "#00f2ff",
  marginTop: 0,
};

const footer = {
  marginTop: 40,
  fontSize: 12,
  opacity: 0.7,
};

export default ContactPage;